<template>
    <div class="logo">
        <h1 class="text-center mb-5">Autenticando...</h1>
    </div>
</template>

<script>
  import { flavorRes, loadFlavor } from '../plugins/flavors'
  import { autenticarNewConParceiro } from '../webservice/autenticar'
  import { alert, findUnidade, notification } from '../plugins/helpers'
  import { origensAcesso } from '@/plugins/constants'
  import { AlertTypes } from '../plugins/alerts_types'

  export default {
    name: 'LoginExternoApi',
    data: () => ({
      logo: ''
    }),
    mounted () {
      this.$session.destroy()
      loadFlavor('rodobens')
      this.logo = flavorRes('img/logo-menu.png')

      const params = this.$route.query
      autenticarNewConParceiro(params.jwt)
        .then(res => {
          this.$session.set('origem_acesso', origensAcesso.api_externa)
          const empresas = res.data.Empresas.Empresa
          const unidades = res.data.UnidadesNegocio

          const empresa = empresas.find(empresa => empresa.CD_Empresa === res.data.Empresa)

          if (empresa) {
            this.$session.set('id_empresa', this.$session.get('vendas_backoffice') ? 0 : empresa.ID_Empresa)
            this.$session.set('empresas', [empresa])
            const filial = res.data['FiliaisVenda']['FilialVenda'].find(filial => filial.ID_Empresa === empresa.ID_Empresa)
            if (filial) {
              this.$session.set('filial', filial)
            }
          } else {
            alert(`A empresa ${res.data.Empresa} é inválida. Consulte a administradora`)
            return
          }
          const unidade = findUnidade(res.data.Un_Negocio, empresa.ID_Empresa, unidades, this.$session.get('vendas_backoffice'))

          if (unidade) {
            this.$session.set('id_unidade_negocio', unidade.id_unidade_negocio)
            this.$session.set('unidades', [unidade])
          } else {
            alert(`A Unidade de Negócio ${res.data.Un_Negocio} é inválida. Consulte a administradora`)
            return
          }

          /** @var id_representante string **/
          let id_representante = params.ext_identificador_representante || null

          if (id_representante && id_representante.length > 30) {
            notification('warning', 'Identificador do representante inválido.')
            return
          }

          this.$session.set('identificador_representante_tribanco', id_representante)

          // noinspection JSIgnoredPromiseFromCall
          this.$router.replace('/')
        })
        .catch(err => {
          notification(AlertTypes.ERROR, err, 'Não foi possível realizar o login!')
        })
    }
  }
</script>

<style scoped>
    .logo {
        width: 100%;
        margin-top: 15px;
    }

    .logo img {
        margin: auto;
        display: block;
    }
</style>
